import { alpha } from '@mui/material/styles';

import type { OverWritable } from '../../@types/settings';
import type { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const varLow = (theme: Theme): string => alpha(theme.palette.grey[900], 0.48);
const varHigh = (theme: Theme): string => alpha(theme.palette.grey[900], 1);

export const backdrop: OverWritable = {
  MuiBackdrop: {
    styleOverrides: {
      root: ({ theme }) => ({
        background: [
          `rgb(22, 28, 36)`,
          `-moz-linear-gradient(75deg, ${varLow(theme)} 0%, ${varHigh(
            theme
          )} 100%)`,
          `-webkit-linear-gradient(75deg, ${varLow(theme)} 0%, ${varHigh(
            theme
          )} 100%)`,
          `linear-gradient(75deg, ${varLow(theme)} 0%, ${varHigh(theme)} 100%)`,
        ],
        '&.MuiBackdrop-invisible': {
          background: 'transparent',
        },
      }),
    },
  },
};
